import { COMPLIANCE_DOCUMENT_CONTENT_TYPES } from '@chukua/common';
import { Form, Upload } from 'antd';
import { UploadCloud } from 'lucide-react';

interface ComplianceDocumentFileFieldProps {
  file: File | null;
  error: boolean;
  onChange: (file: File | null) => void;
}

/** The file-drop field every truck/trailer compliance-document modal collects (gitaumoses4/chukua#17) — always required, since a new document always ships with a scan. */
export function ComplianceDocumentFileField({ file, error, onChange }: ComplianceDocumentFileFieldProps) {
  return (
    <Form.Item label="File" required>
      <Upload.Dragger
        accept={COMPLIANCE_DOCUMENT_CONTENT_TYPES.join(',')}
        multiple={false}
        maxCount={1}
        beforeUpload={(next) => {
          onChange(next);
          return false;
        }}
        onRemove={() => onChange(null)}
      >
        <p className="flex flex-col items-center gap-2 py-4 text-sm text-muted">
          <UploadCloud className="size-5" />
          {file ? file.name : 'Click or drag a PDF, JPEG or PNG'}
        </p>
      </Upload.Dragger>
      {error && <p className="mt-1 text-sm text-error">A file is required</p>}
    </Form.Item>
  );
}
